import { ResultSet } from './ResultSet';
export class FilterResult {
    constructor(query) {
        this._query = query;
        this._result = new ResultSet();
    }
    get query() {
        return this._query;
    }
    get result() {
        return this._result;
    }
    addRow(row) {
        this.result.add(row);
    }
}
